export default "__VITE_ASSET__f3e4e549__"